import { BaseRequestOptions, RequestOptions, XHRBackend, Headers } from "@angular/http";
import { DefaultUrlSerializer, UrlTree } from "@angular/router";
import { Configuration } from "../configurations/shared.config";
import { HttpService } from "./http.service";


export class FMSBaseRequestOptions extends BaseRequestOptions {

    withCredentials: boolean = true;

    constructor() {
        super()
        this.headers = new Headers({
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json'
        });
    }
}

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
    parse(url: string): UrlTree {
        if (typeof url !== 'string') url = '';

        let queryStringStartIndex = url.indexOf('?');
        if (queryStringStartIndex > -1) {
            let urlWithoutQueryString = url.substr(0, queryStringStartIndex).toLowerCase();
            url = urlWithoutQueryString + url.substr(queryStringStartIndex);
        } else {
            url = url.toLowerCase();
        }

        return super.parse(url);
    }
}

export function httpServiceFunction(backend: XHRBackend, defaultOptions: RequestOptions) {
    return new HttpService(backend, defaultOptions);
}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/http-utilities.service.ts